module.exports = __webpack_public_path__ + "img/bg-strip-rotate.69de0286.svg";